import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User } from './../models/User';
import { Injectable } from '@angular/core';
import { environment } from './../../environments/environment';
import { Location } from '@angular/common';




@Injectable({
  providedIn: 'root'
})
export class FileServer {
  protected fs_images = environment.fileserver.images;
  protected fs_public = environment.fileserver.public;
  protected api_root =environment.api.root;
  

  constructor(
    protected location: Location,
    private http: HttpClient
  ) { }

  getImage(path) {
    return this.location.normalize(this.fs_images + path);
  }
  
  getPublicImage(path) {
    return this.location.normalize(this.fs_public + path);
  }

  getFile(path){
    return this.location.normalize(`${this.api_root}/`+path);
  }

  getAvatar(user: User | any, size = null) {
    if (!user.avatar) {
      return '';
    }
    let path = user.avatar;
    if (path) {
      if (size) {
        path = path.replace('/avatar.', `/${size}.`);
      }
      return this.location.normalize(this.fs_images + path);
    }
  }

  downloadFile(path, filename = null, mime = null) {

    return new Promise((resolve, reject) => {
      let headers = {};
      if (mime) {
        headers['Content-Type'] = mime;
      }
      this.http.get(this.getFile(path), {
        headers: new HttpHeaders(headers), responseType: 'blob', observe:'response'
      })
        .toPromise()
        .then(data => {
          filename=data.headers.get('Content-Filename');
          const file = mime ? new Blob([data.body], { type: mime }) : new Blob([data.body]);
          const element = document.createElement('a');
          element.href = URL.createObjectURL(file);
          if (filename) {
            element.download = filename;
          }
          document.body.appendChild(element);
          element.click();
          resolve(true);
        }).catch(error => {
          reject(error)
        });

    });
  }
}
